export function canRegenerateDailyInsight({ isToday, hasAiFeature, isGenerating }) {
  return Boolean(isToday && hasAiFeature && !isGenerating);
}
